// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bm1F","newExpiryDate":"styles_newExpiryDate__qO3Az","footer":"styles_footer__27Ft4"};